var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70878 6.55005L0.519244 9.1086C0.175638 9.51889 0.239412 10.1244 0.683451 10.4536C1.10055 10.7709 1.74095 10.7223 2.09379 10.3025L4.0498 8.06589C3.27868 7.88494 2.76223 7.24381 2.70878 6.55005Z",
    stroke: "#444444",
    strokeWidth: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69734 3.96822C8.51664 3.96822 9.18252 3.30447 9.18252 2.48521C9.18252 1.66594 8.51664 1 7.69734 1C6.8803 1 6.21436 1.66594 6.21436 2.48521C6.21436 3.30447 6.8803 3.96822 7.69734 3.96822Z",
    stroke: "#444444",
    strokeWidth: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77201 4.7853H8.04369C7.829 4.7853 7.62088 4.71084 7.45882 4.57064C7.45663 4.56845 7.45005 4.56187 7.44128 4.55532C7.2594 4.35813 5.85749 2.89485 4.42705 3.10733H1.93422C1.47198 3.10733 1.09521 3.4841 1.09521 3.94633C1.09521 4.40854 1.47198 4.7853 1.93422 4.7853H4.0875L3.08207 6.0624C2.43486 6.88561 3.02594 8.08647 4.06343 8.08647C4.53658 8.08647 4.98127 8.2924 5.28573 8.64949L4.35912 9.32421C3.82817 9.67812 3.8109 10.4462 4.3219 10.8247C4.63498 11.052 5.05566 11.0608 5.37996 10.8356L6.75126 9.86084C7.05572 9.64614 7.2507 9.29131 7.28791 8.88385C7.32512 8.46543 7.19157 8.07115 6.93304 7.81046L6.1335 6.88166L6.61761 6.24203L6.86736 6.42168C6.90459 6.45013 6.94838 6.46329 6.99438 6.46329H9.77201C10.2342 6.46329 10.611 6.08651 10.611 5.62428C10.611 5.1621 10.2342 4.7853 9.77201 4.7853Z",
    stroke: "#444444",
    strokeWidth: 0.55
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnActivity);
export default __webpack_public_path__ + "static/media/icn_activity.925c67c1.svg";
export { ForwardRef as ReactComponent };